import { QuestionPlanIsUncancelable as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-uncancelable";

import { usePlanIsUncancelable } from "./hooks";

export const QuestionPlanIsUncancelable = () => {
	const { isUncancelable, onSetIsUncancelable } = usePlanIsUncancelable();

	return <Question isUncancelable={isUncancelable} onSetIsUncancelable={onSetIsUncancelable} />;
};

QuestionPlanIsUncancelable.displayName = "QuestionPlanIsUncancelable";
